import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { RevoGridService } from 'src/app/shared/revogrid.service';
import { RevoGrid } from '@revolist/revogrid/dist/types/interfaces';

@Component({
    selector: 'app-user-activity-popup',
    templateUrl: './user-activity-popup.component.html',
    styleUrls: ['./user-activity-popup.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UserActivityPopupComponent implements OnInit {
    @Input() activityList: any[] = [];

    source: any[] = [];
    columns: RevoGrid.CellProps[] = [];

    get descriptionSize() {
        let diff = 370;
        let width = 1200 - diff;
        let windowWidth = (window.innerWidth * 0.9) - diff;
        let minWidth = Math.min(width, windowWidth);
        return Math.max(minWidth, diff);
    }

    get revoGrid() {
        const grid: any = document.querySelector("revo-grid");
        return grid;
    }

    constructor(private revoGridService: RevoGridService) {

    }

    ngOnInit(): void {
        var columns = [
            { prop: 'Created', name: 'Erstellt', type: 'date', dateFormat: 'dd MMM YYYY hh:mm:ss a', autoSize: true, size: 220 },
            { name: 'Typ', prop: 'Type', type: 'string', autoSize: true, size: 150 },
            { prop: 'Description', name: 'Beschreibung', type: 'string', autoSize: true, size: this.descriptionSize }
        ];

        this.columns = this.revoGridService.generateRevoGridColumns(columns);

        this.source = [...this.activityList];
    }

}
